import { render, staticRenderFns } from "./TabletMenu.vue?vue&type=template&id=3a2e5aee&scoped=true&"
import script from "./TabletMenu.vue?vue&type=script&lang=js&"
export * from "./TabletMenu.vue?vue&type=script&lang=js&"
import style0 from "./TabletMenu.vue?vue&type=style&index=0&id=3a2e5aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e5aee",
  null
  
)

export default component.exports